import { StrictMode } from 'react'
import './index.css'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import NotFoundPage from "./layout/NotFoundPage.tsx";
import PendingPage from "./layout/PendingPage.tsx";
import Footer from "./layout/Footer.tsx";

// Import the generated route tree
import { routeTree } from './routeTree.gen.ts'
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

// Create a new router instance
const router = createRouter({
    routeTree,
    defaultNotFoundComponent: NotFoundPage,
    defaultPendingComponent: PendingPage,
    defaultPreload: "intent",
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router
    }
}

// App Layout with Sticky Footer
const App = () => {
    return (
        <div className="flex flex-col min-h-screen">
            {/* Main Content */}
            <main className="flex-grow">
                <RouterProvider router={router}/>
            </main>
        </div>
    );
};

const queryClient = new QueryClient();

// Render the app
const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement)
    root.render(
        <StrictMode>
            <QueryClientProvider client={queryClient}>
            <App/>
            </QueryClientProvider>
        </StrictMode>,
    )
}
